import { FC } from 'react'

import { Tooltip } from '@material-ui/core'
import Switch from '@mui/material/Switch'
import {
  TableFooter,
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  Span,
  Copy
} from 'components'
import { StatusIcon, MagnifyingGlassIcon } from 'components/Icons'
import { Link } from 'components/Link/Link'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import { COLORS, FORMAT } from 'utils'

import { ItemCarteiras } from '../../AnalyzeCre'

interface ITableSearchCre {
  page: number
  setPage: (_page: number) => void
  rowsPerPage: number
  rowsSize: number
  areDatesValid: () => boolean
  setRowsPerPage: (_page: number) => void
  tableData: ItemCarteiras[]
  handleVerContrato: (_id) => void
}

export const TableAnalyzeCre: FC<ITableSearchCre> = ({
  page,
  rowsSize,
  rowsPerPage,
  setRowsPerPage,
  areDatesValid,
  setPage,
  tableData,
  handleVerContrato
}) => {
  const history = useHistory()
  const formatDate = (date: string | Date) => {
    return moment(date).format('YYYY') === '0001'
      ? '- - - - - -'
      : moment(date).format('DD/MM/YYYY')
  }

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value))
    setPage(1)
  }

  const handleStatus = (status: string) => {
    if (
      status === 'Green' ||
      status === 'Aprovado' ||
      status === 'Liberado' ||
      status === 'L'
    )
      return 'Todos os documentos liberados, após análise'
    if (
      status === 'Yellow' ||
      status === 'Analisar' ||
      status === 'Analisando' ||
      status === 'PendenteDocumento' ||
      status === 'P'
    )
      return 'CRE analisado, com pendências'
    return 'Pendência de Análise'
  }

  const handleClickItemCre = (data: ItemCarteiras) => {
    const competenciaValue = FORMAT.formatYYYYMM(
      String(data.content.competencia)
        .split('/')
        .reverse()
        .toString()
        .replace('/', '')
    )
    history.replace({
      pathname: '/ngt/analise-cre',
      state: {
        cdContrato: data.content.contrato,
        dtCompetencia: competenciaValue,
        idCreExist: data.content.idCre,
        nmFornecedor: data.content.fornecedor,
        pathBack: '/ngt/analise-cre',
        tab: 0
      }
    })
  }

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled align="left"></TableCellStyled>
              <TableCellStyled align="left">Contrato</TableCellStyled>
              <TableCellStyled>Fornecedor</TableCellStyled>
              <TableCellStyled align="left">Competência</TableCellStyled>
              <TableCellStyled align="left">CRE</TableCellStyled>
              <TableCellStyled align="left">Bloq.Pag </TableCellStyled>
              <TableCellStyled>Analista</TableCellStyled>
              <TableCellStyled align="left">Data Liberação</TableCellStyled>
              <TableCellStyled align="left">Data Retorno</TableCellStyled>
              <TableCellStyled align="center">Status</TableCellStyled>
              <TableCellStyled align="center">Ação</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {tableData?.map((row) => (
              <TableRowStyled key={row.content.idCreItem}>
                <TableCellStyled align="left">
                  <Copy
                    title="Copiar código de contrato"
                    valueToCopy={row.content.contrato}
                  />
                </TableCellStyled>
                <TableCellStyled
                  align="left"
                  onClick={() => handleVerContrato(row.content.idContrato)}
                >
                  <Span
                    text={row.content.contrato || '- - -'}
                    color={COLORS.blueFonts}
                  />
                </TableCellStyled>
                <TableCellStyled>
                  {row.content?.fornecedor ||
                    row.content?.nmFornecedor ||
                    '- - -'}
                </TableCellStyled>
                <TableCellStyled align="left">
                  {FORMAT.competencia(row.content?.competencia) || '- - -'}
                </TableCellStyled>
                <TableCellStyled align="left">
                  {row.content?.cre || row.content?.cdCre || '- - -'}
                </TableCellStyled>
                <TableCellStyled align="left">
                  <Switch
                    checked={
                      row.content?.bloqPag ||
                      row.content?.flCreBloqueado ||
                      false
                    }
                    id="switchCre"
                    onClick={(e) => e.preventDefault()}
                  />
                </TableCellStyled>
                <TableCellStyled>
                  {row.content.analista ||
                    row.content.usuarioAnalista ||
                    '- - -'}
                </TableCellStyled>
                <TableCellStyled align="left">
                  {row.content?.dataLiberacao}
                </TableCellStyled>
                <TableCellStyled align="left">
                  {row.content?.dataRetorno || '- - - -'}
                </TableCellStyled>
                <Tooltip
                  arrow
                  title={handleStatus(row.content?.status)}
                  placement="left"
                >
                  <TableCellStyled align="center">
                    <StatusIcon
                      value={row.content?.status}
                      marginLeft="auto"
                      marginRight="auto"
                    />
                  </TableCellStyled>
                </Tooltip>
                <TableCellStyled align="center">
                  <Link onClick={() => handleClickItemCre(row)}>
                    <MagnifyingGlassIcon marginLeft="10px" />
                  </Link>
                </TableCellStyled>
              </TableRowStyled>
            ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page - 1}
        rows={tableData}
        totalItems={rowsSize}
        disabled={!areDatesValid()}
        rowsPerPage={rowsPerPage}
        handleChangePage={(pageNumber) => setPage(pageNumber + 1)}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        typeFooter="offline"
      />
    </>
  )
}
